import styled from "styled-components"
import theme from "../../theme"

const ModalCardFooter = styled<any, "footer">("footer")`
  display: flex;
  border-top: 1px solid #dbdbdb;
  align-items: center;
  background-color: #f5f5f5;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
  position: relative;
  z-index: 2;
  background: ${theme.colors.modalFooter};
  color: ${theme.colors.text};
`

export default ModalCardFooter
